module.exports = __webpack_public_path__ + "static/img/new-jiayin-header.1306d6fa.png";